const CHART_MARGIN = {
  margin: {
    top: 30,
    right: 50,
    bottom: 60,
    left: 80,
  },
}

export const SCATTERPLOT_PROPS: any = {
  ...CHART_MARGIN,
  innerRadius: 0.5,
  cornerRadius: 3,
  padAngle: 1.5,
  slicesLabelsSkipAngle: 25,
  slicesLabelsTextColor: 'inherit:darker(1.6)',
}
